import { Button } from '@mui/material'
import { useFirmPathResolver } from '~/src/hooks/router/useFirmPathResolver'
import { useRouterPush } from '~/src/hooks/router/useRouterPush'
import { useTranslations } from '~/src/hooks/useTranslations'
import routes from '~/src/router/enums/routes.enum'

const CheckoutCancelButton = () => {
  const { t } = useTranslations()
  const { resolve } = useFirmPathResolver()
  const { push } = useRouterPush()

  const handleOnClick = () => {
    push(resolve(routes.FIRM_HOME))
  }

  return (
    <Button
      variant='outlined'
      disableElevation={true}
      onClick={handleOnClick}
      sx={{
        borderRadius: 'var(--btn-border-radius)'
      }}
    >
      {t('footer.cancel')}
    </Button>
  )
}

export default CheckoutCancelButton
